import React from 'react';
import Button from '@material-ui/core/Button';
import MenuIcon from '@material-ui/icons/Menu';
import ClickAwayListener from '@material-ui/core/ClickAwayListener';
import Grow from '@material-ui/core/Grow';
import Paper from '@material-ui/core/Paper';
import Popper from '@material-ui/core/Popper';
import MenuItem from '@material-ui/core/MenuItem';
import MenuList from '@material-ui/core/MenuList';
import { makeStyles } from '@material-ui/core/styles';
import Link from '@material-ui/core/Link';
const useStyles = makeStyles((theme) => ({
    root: {
        display: 'flex',
    },
    paper: {
        marginRight: theme.spacing(2),
    },
    menubutton: {
        margin: "0 0 0 auto",
        marginTop: theme.spacing(0.75),
    },
    link: {
        color: theme.palette.secondary.main,
        '&:hover': {
            color: theme.palette.secondary.dark
        }

    }
}));

export default function MenuListComposition() {
    const classes = useStyles();
    const [open, setOpen] = React.useState(false);
    const anchorRef = React.useRef(null);

    const handleToggle = () => {
        setOpen((prevOpen) => !prevOpen);
    };

    const handleClose = (event) => {
        if (anchorRef.current && anchorRef.current.contains(event.target)) {
            return;
        }

        setOpen(false);
    };

    function handleListKeyDown(event) {
        if (event.key === 'Tab') {
            event.preventDefault();
            setOpen(false);
        }
    }

    // return focus to the button when we transitioned from !open -> open
    const prevOpen = React.useRef(open);
    React.useEffect(() => {
        if (prevOpen.current === true && open === false) {
            anchorRef.current.focus();
        }

        prevOpen.current = open;
    }, [open]);

    return (
        <div className={classes.root}>
            <Button
                ref={anchorRef}
                aria-controls={open ? 'menu-list-grow' : undefined}
                aria-haspopup="true"
                onClick={handleToggle}
                color="secondary"
                className={classes.menubutton}
                style={{ outline: "none" }}
            >
                <MenuIcon />
            </Button>
            <Popper open={open} anchorEl={anchorRef.current} role={undefined} transition disablePortal>
                {({ TransitionProps, placement }) => (
                    <Grow
                        {...TransitionProps}
                        style={{ transformOrigin: placement === 'bottom' ? 'center top' : 'center bottom' }}
                    >
                        <Paper>
                            <ClickAwayListener onClickAway={handleClose}>
                                <MenuList autoFocusItem={open} id="menu-list-grow" onKeyDown={handleListKeyDown}>
                                    <Link href='/' style={{ textDecoration: "none" }}><MenuItem onClick={handleClose} className={classes.link}>Home</MenuItem></Link>
                                    <Link href='/overmij' style={{ textDecoration: "none" }} ><MenuItem onClick={handleClose} className={classes.link}>Over mij</MenuItem></Link>
                                    <Link href='/reiki' style={{ textDecoration: "none" }} ><MenuItem onClick={handleClose} className={classes.link}>Wat is Reiki</MenuItem></Link>
                                    <Link href='/behandeling' style={{ textDecoration: "none" }} ><MenuItem onClick={handleClose} className={classes.link}>Behandeling</MenuItem></Link>
                                    <Link href='/tarieven' style={{ textDecoration: "none" }} ><MenuItem onClick={handleClose} className={classes.link}>Tarieven</MenuItem></Link>
                                    <Link href='/contact' style={{ textDecoration: "none" }} ><MenuItem onClick={handleClose} className={classes.link}>Contact</MenuItem></Link>
                                </MenuList>
                            </ClickAwayListener>
                        </Paper>
                    </Grow>
                )}
            </Popper>
        </div>
    );
}
